<template>
  <div class="Scale_classification">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="background-color: #fff;padding: 14px;">
      <el-form-item label="量表代号">
        <el-input v-model="formInline.user" placeholder="量表代号"></el-input>
      </el-form-item>
      <el-form-item label="量表名称">
        <el-input v-model="formInline.user" placeholder="量表名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="Scale_classification_nav">
      <div class="Scale_classification_nav_left">
        <scales @sendmsg="getmsg"></scales>
      </div>
      <div class="Scale_classification_nav_right">
        <el-button type="primary" style="margin-left: 1%;margin-top: 14px;" @click="addfun()">新增</el-button>
        <el-table :data="tableData" style="width: 98%;margin-left: 1%;margin-top: 14px;">
          <el-table-column prop="factorName" label="因子名称" width="180"></el-table-column>
          <el-table-column prop="paperName" label="量表名称" width="180"></el-table-column>
          <el-table-column prop="lineNumber" label="因子排序"></el-table-column>
          <el-table-column prop="isActive" label="是否启用">
            <template slot-scope="scope">
              <span>{{scope.row.isActive ==1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="描述"></el-table-column>
          <el-table-column prop="createdDate" label="创建日期"></el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
              <span class="w" @click="xg(scope.row)">修改</span>
              <span class="w" @click="delfun(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  import scales from '@/components/scales.vue'
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: []
      };
    },
    components:{
      scales
    },
    methods: {
      xg(row){
        this.$router.push({
          path: '/Scale/Add_factor_problem',
          query: { factorID:row.factorID, paperCode:row.paperCode,name:row.paperName},
        })
      },
      delfun(row){
        var ji = [row.factorID];
        this.$Http_Post('paperconfig/factor/delete', {factorIDs:ji}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      getmsg(val){//量表点击时子组件传过来值
        this.$Http_Post('paperconfig/questioncfg/list', {paperCode:val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      addfun() {
        this.$router.push({
          path: '/Scale/Add_factor_answer',
        })
      },
      onSubmit() {
        console.log('submit!');
      },
      handleNodeClick(data) {

      }
    }
  };
</script>
<style>
.Scale_classification{width: 100%;height: 100%;}
.Scale_classification_nav{width: 100%;height: calc(100% - 104px);margin-top: 14px;}
.Scale_classification_nav_left{width: 450px;height: 100%;overflow: auto;float: left;background-color: #fff;}
.Scale_classification_nav_right{width: calc(100% - 464px);height: 100%;float: right;background-color: #fff;}
</style>